import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';

/**
 * Routes "/" → /portfolio (the org-level home), or /login if not signed in.
 *
 * Per spec §6/U2 the app index ALWAYS lands on /portfolio, never on the first
 * brand — the org layer is the home surface. Users with zero brands still see
 * Portfolio (which renders its own empty state + onboard CTA), so there is no
 * /no-access bounce here.
 */
export default function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-text-muted">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to="/portfolio" replace />;
}
